export type ParsedStory = {
  slug: string;
  title: string;
  date: string;
  image: string;
  tags?: string[];
  link?: string;
  body: string;
};

export const parseStoryFile = (
  text: string,
  filename: string
): ParsedStory => {
  const lines = text.split('\n');

  return {
    slug: filename.replace('.txt', ''),
    title: lines[0]?.trim(),
    date: lines[1]?.trim(),
    image: lines[2]?.trim(),
    tags: lines[3]?.trim() ? lines[3].split(',').map(tag => tag.trim()) : [],
link: lines[4]
  ? lines[4].substring(lines[4].indexOf('=') + 1).trim()
  : '',
      body: lines.slice(5).join('\n').trim(),
  };
};
